import { motion } from "framer-motion";
import { useEstimate } from "../context/EstimateContext";

const CHAPTERS = [
  {
    n: "01",
    title: "We listen before we build",
    text: "Every project starts with a real conversation and a free on-site walkthrough — so the estimate reflects your home, not a template.",
  },
  {
    n: "02",
    title: "One crew, from frame to finish",
    text: "No revolving subs or handoffs. The same trusted Apex team carries your project from demolition through the final coat of paint.",
  },
  {
    n: "03",
    title: "Built to code, built to last",
    text: "Fully licensed and insured. We build it right the first time so it passes inspection and holds up for decades.",
  },
  {
    n: "04",
    title: "We finish what we start",
    text: "Clear timelines, honest pricing, and a final walkthrough where you sign off — not us. Your satisfaction closes the job.",
  },
];

export const Manifesto = () => {
  const { openEstimate } = useEstimate();
  return (
    <section id="why" className="bg-[var(--apex-surface)] border-y border-slate-200">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-24 lg:py-32">
        <div className="grid lg:grid-cols-12 gap-8 lg:gap-16">
          <div className="lg:col-span-4">
            <div className="lg:sticky lg:top-28">
              <p className="text-xs font-semibold uppercase tracking-[0.22em] text-[var(--apex-accent)]">Our approach</p>
              <h2 className="font-display font-black text-4xl sm:text-5xl text-[var(--apex-primary)] mt-4 leading-[1.05]">
                How we earn your trust
              </h2>
              <p className="mt-5 text-slate-600 leading-relaxed">
                Four principles that guide every remodel we take on across the Lehigh Valley.
              </p>
              <button
                data-testid="manifesto-estimate-btn"
                onClick={openEstimate}
                className="mt-8 rounded-sm bg-[var(--apex-primary)] hover:bg-slate-800 text-white font-semibold px-7 py-4 transition-colors"
              >
                Start your project
              </button>
            </div>
          </div>

          <div className="lg:col-span-8">
            {CHAPTERS.map((c, i) => (
              <motion.div
                key={c.n}
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-80px" }}
                transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
                className="group grid grid-cols-[auto_1fr] gap-6 sm:gap-10 py-8 border-t border-slate-300 first:border-t-0"
              >
                <span className="font-display font-black text-3xl sm:text-5xl text-slate-300 group-hover:text-[var(--apex-accent)] transition-colors duration-500 tabular-nums">
                  {c.n}
                </span>
                <div className="pt-1">
                  <h3 className="font-display font-bold text-2xl sm:text-3xl text-[var(--apex-primary)]">{c.title}</h3>
                  <p className="mt-3 text-slate-600 leading-relaxed max-w-xl">{c.text}</p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
